import React, { useState, useEffect } from "react";
import { Country, State } from "country-state-city";

const ShippingAddress = ({ address, setAddress }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [states, setStates] = useState([]);
  const allCountries = Country.getAllCountries();

  // Load saved address from localStorage on component mount
  useEffect(() => {
    const savedAddress = JSON.parse(localStorage.getItem("shippingAddress"));
    if (savedAddress) {
      setAddress({
        country: savedAddress.country === "0" ? "" : savedAddress.country,
        state: savedAddress.state === "0" ? "" : savedAddress.state,
        town: savedAddress.town === "0" ? "" : savedAddress.town,
        pin_code: savedAddress.pin_code === "0" ? "" : savedAddress.pin_code
      });
      
      // If country is set, load its states
      if (savedAddress.country && savedAddress.country !== "0") {
        const selectedCountry = allCountries.find(c => c.name === savedAddress.country);
        if (selectedCountry) {
          setStates(State.getStatesOfCountry(selectedCountry.isoCode));
        }
      }
    }
  }, []);

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "country") {
      const selectedCountry = allCountries.find((c) => c.name === value);
      setStates(selectedCountry ? State.getStatesOfCountry(selectedCountry.isoCode) : []);
    }
  };

  const toggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);

  return (
    <div className="col-span-full mt-6">
      <div className="flex items-center flex-col justify-start w-full py-2 text-left text-sm font-medium text-gray-700">
        <div className="w-full">
          <p className="text-gray-400 text-[1rem]">Shipping</p>
          <p className="text-gray-500">Enter your address to view shipping options.</p>
        </div>
        <p onClick={toggleAccordion} className="w-full mt-2 text-red-500 cursor-pointer">
          Calculate shipping
        </p>
      </div>

      {isAccordionOpen && (
        <div className="mt-4 space-y-4 p-4">
          <div>
            <label htmlFor="country" className="block text-sm text-left font-medium text-gray-700">Country / region</label>
            <select
              id="country"
              name="country"
              value={address.country}
              onChange={handleAddressChange}
              className="w-full border px-3 py-1.5 bg-white text-gray-900 placeholder:text-gray-400 sm:text-sm/6 focus:outline-none"
            >
              <option value="">Select a country</option>
              {allCountries.map((country) => (
                <option key={country.isoCode} value={country.name}>{country.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="state" className="block text-left text-sm font-medium text-gray-700">State / County (optional)</label>
            <select
              id="state"
              name="state"
              value={address.state}
              onChange={handleAddressChange}
              className="w-full border px-3 py-1.5 bg-white text-gray-900 focus:outline-none"
            >
              <option value="">Select a state</option>
              {states.map((state) => (
                <option key={state.isoCode} value={state.name}>{state.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="town" className="block text-sm text-left font-medium text-gray-700">Town / City *</label>
            <input
              type="text"
              id="town"
              name="town"
              value={address.town}
              onChange={handleAddressChange}
              className="w-full border px-3 py-1.5 bg-white text-gray-900 focus:outline-none"
              placeholder="Enter your town/city"
            />
          </div>
          <div>
            <label htmlFor="pin_code" className="block text-sm text-left font-medium text-gray-700">PIN Code *</label>
            <input
              type="text"
              id="pin_code"
              name="pin_code"
              value={address.pin_code}
              onChange={handleAddressChange}
              className="w-full border px-3 py-1.5 bg-white text-gray-900 focus:outline-none"
              placeholder="Enter your PIN code"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ShippingAddress;